import { format, isToday, isValid, parseISO } from 'date-fns';

const SERVICE_CHANNEL_WO_BASE_URL = 'https://www.servicechannel.com/sc/wo/Workorders/index?id=';

export const normalizeServiceChannelWo = (input: string): string => {
  const match = input.match(/id=(\d+)/i);
  return match ? match[1] : input.trim();
};

export const serviceChannelWoUrl = (wo: string): string => `${SERVICE_CHANNEL_WO_BASE_URL}${wo}`;

export const parseSlaDue = (value: string | undefined): Date | undefined => {
  if (!value || value.startsWith('0001-01-01')) return undefined;
  const d = parseISO(value.replace(' ', 'T'));
  return isValid(d) ? d : undefined;
};

export const formatSlaDueHint = (value: string | undefined): string | undefined => {
  const d = parseSlaDue(value);
  if (!d) return undefined;
  return isToday(d) ? `Due today ${format(d, 'h:mm a')}` : `Due ${format(d, 'MMM d, h:mm a')}`;
};
